namespace $ { $mol_style_attach( "mol/dimmer/demo/demo.view.css",
 "[mol_dimmer_demo_cases] > * {\n\tpadding: var(--mol_gap_text);\n}\n"
) }